import { Component, Prop, h, Host, Event, EventEmitter, } from '@stencil/core';

@Component({
  tag: 'dda-radiobutton',
  styleUrls: ['dda-radiobutton.css'],
  shadow: false,
})
export class DdaRadiobutton {
  @Prop() title_text: string;
  @Prop() supporting?: string;
  @Prop() group_name?: string;
  @Prop() input_id?: string;
  @Prop({ reflect: true, mutable: true }) checked: boolean = false;
  @Prop() radio_status?: string;
  @Prop() error_message: string;
  @Prop() validation_type?: string;
  @Prop() validation_id: string = 'text';
  @Prop() size?: string;
  @Prop() variants?: string;
  @Prop() custom_class?: string = '';
  @Prop() component_mode?: string;
  @Prop() aria_label?: string;
  @Prop() contrast_noraml_text?: string;

  // Emits event to parent component
  @Event() radioChange: EventEmitter<{ checked: boolean; input_id: string }>;
  @Event() onChanged: EventEmitter<{ checked: boolean; input_id: string }>;


  private handleChange = (_e: Event) => {
    this.checked = true;
    this.radioChange.emit({ checked: this.checked, input_id: this.input_id });
    this.onChanged.emit({ checked: this.checked, input_id: this.input_id });
  };

  render() {
    const radiobuttonClass = [
      'dda-radio-container',
      this.validation_type ? `dda-validation-${this.validation_type}` : '',
      this.size ? `dda-radio-${this.size}` : '',
      this.variants ? `dda-radio-${this.variants}` : '',
      this.custom_class ? `dda-radio-${this.custom_class}` : '',
      this.radio_status ? `dda-radio-${this.radio_status}` : '',
      this.component_mode,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <Host>
        <div class={radiobuttonClass}>
          <input
            type="radio"
            id={this.input_id}
            name={this.group_name}
            aria-label={this.aria_label}
            checked={this.checked}
            disabled={this.radio_status === 'disabled'}
            onChange={this.handleChange}
          />
          <label htmlFor={this.input_id}>
            <span class="radio-circle"></span>
            <p>
              <span class="radio-title">{this.title_text}</span>
              {this.validation_type === 'error' && this.error_message ? (
                <span class="radio-error-message" id={this.validation_id}>
                  {this.error_message}
                </span>
              ) : (
                this.supporting && (
                  <span class="dda-helper-text" id={this.validation_id}>
                    {this.supporting}
                  </span>
                )
              )}
            </p>
          </label>
        </div>
      </Host>
    );
  }
}
